import Control from "../../Control";
import TextField from "../TextField/TextField";
import DropPanel from "../DropPanel/DropPanel";
import Calendar from "../Calendar/Calendar";
import NP from "../../NP";
import Delegate from "../../Delegate";

let moment = require('moment');

export default class DateInput extends Control {
	public EvChanged: Delegate;

	private _dateInput: TextField;

	private _FloatingLabel: string;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._FloatingLabel = null;
		this.EvChanged = new Delegate();
		this._Value = new Date();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('date-input')
		this._dateInput = new TextField({
			ParentNode: this._root,
			FloatingLabel: this._FloatingLabel,
			FontImage: NP.FontImages.event,
			EnabledEdit: false,
			Value: this._Value ? moment(this._Value).format(NP.getDayFormat()): '',
			EvFocus: (sender: TextField) => this.showCalendar(sender)
		});
	}

	setValue(value: Date)
	{
		this._Value = value;
		this._dateInput.setValue(this._Value ? moment(this._Value).format(NP.getDayFormat()) : '')
	}

	setEnabled(value: boolean, reInit?: boolean)
	{
		super.setEnabled(value, reInit);
		if (this._dateInput)
			this._dateInput.setEnabled(value)
	}


	private showCalendar(textField: TextField)
	{
		let dropPanel = new DropPanel({
			AutoClose: true,
			EnableResize: false,
			Content: new Calendar({
				Value: this._Value,
				EvDateChanged: (calendar: Calendar) =>
				{
					this._Value = calendar.getValue();
					textField.setValue(moment(this._Value).format(NP.getDayFormat()));
					dropPanel.destroy();

					this.EvChanged.fire(this);
				}
			})
		});
		NP.showDropPanel(dropPanel, textField.getRoot(), NP.LTRB.Bottom, undefined, true);
	}
}